import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { TOptionType } from "../../../types/CustomSelect";
import Multiselect from "multiselect-react-dropdown";
import CustomArrow from "../../../utils/CustomStyleComponent/ArrowComponent";
import CustomCrossButton from "../../../utils/CustomStyleComponent/CrossButtonComponent";
import { toast } from "react-toastify";
import { TRegionFilterProps } from "../../../types/Filters/RegionsFilter";
import { getRegion } from "../../../app/request/regionRequest";
import CustomTooltip1 from "../../../utils/CustomStyleComponent/TooltipNewComponent";
import "../../../app/pages/Units/UnitsForm.css";

const RegionFilter = ({onRegionFilterChange, currentRegionFilter, queryForAll}: TRegionFilterProps) => {
  const [allRegion, setAllRegion] = useState<Array<{ id: string; regionName: string }>>([]);

  const style = {
    multiSelectContainer: {
      minheight: "44px",

      border: "1px solid var(--bs-gray-100)",

      // styles for the multiselect container
    },
    searchBox: {
      minheight: "44px",
      fontWeight: "500",
      minwidth: "40px",
      maxwidth: "40px",
      height: "44px",
      display: "flex",
      alignItems: "center",
      width: "230px",

      // styles for the search wrapper
    },
    chips: {
      // To change css chips(Selected options)
      marginBottom: "0",
    },
  };

  useEffect(() => {
    const fn = async () => {
      try {
        const response = await getRegion(`page=1&limit=100${queryForAll ? queryForAll:""}`);
        if (response.data.status) {
          setAllRegion(response.data.data.data);
        } else {
          toast.error("Something went wrong");
        }
      } catch (error) {
        toast.error("Network Error");
      } finally {
      }
    };
    fn();
  }, []);

  const handleRegionFilter = useCallback(
    (data: any) => {
     onRegionFilterChange(data)
    },
    []
  );


  const getSelectedValues = () => {
    if (currentRegionFilter) {
    
      if (typeof currentRegionFilter === 'string' && currentRegionFilter) {
        const regionIds = (currentRegionFilter as string).split(',').map(id => id.trim());
        return allRegion.filter(region => 
          regionIds.includes(region.id) || regionIds.includes(region.regionName)
        );
      }
     
      else if (Array.isArray(currentRegionFilter) && currentRegionFilter.length > 0) {
        return allRegion.filter(region => 
          currentRegionFilter.some(filterRegion => 
            region.regionName === filterRegion ||
            region.id === filterRegion ||
            (typeof filterRegion === 'object' &&
              ('regionName' in filterRegion && region.regionName === (filterRegion as any).regionName) ||
              ('id' in filterRegion && region.id === (filterRegion as any).id)
            )
          )
        );
      }
      
      else if (typeof currentRegionFilter === 'object' && !Array.isArray(currentRegionFilter)) {
        return allRegion.filter(region => 
          ('regionName' in currentRegionFilter && region.regionName === (currentRegionFilter as any).regionName) ||
          ('id' in currentRegionFilter && region.id === (currentRegionFilter as any).id)
        );
      }
    }
    return [];
  };

  return (
    <Multiselect
      options={allRegion}
      displayValue="regionName"
      placeholder="Select Region"
      style={style}
      showArrow={true}
      hidePlaceholder={true}
      selectionLimit={2}
      customArrow={<CustomArrow />}
      customCloseIcon={<CustomCrossButton />}
      avoidHighlightFirstOption={true}
      showCheckbox={true}
      onSelect={handleRegionFilter}
      onRemove={handleRegionFilter}
      selectedValues={getSelectedValues()}
      selectedValueDecorator={(value: string, option: any) => {
        return (
          <CustomTooltip1 value={value} truncated={true} option={option}/>
        );
      }}
    />
  );
};

export default React.memo(RegionFilter);
